import styled from '@emotion/styled';

export const Card = styled.div`
    border: 2px solid ${({ theme }) => theme.color.grey2};
    background-color: ${({ theme }) => theme.color.grey3};
    border-radius: 4px;
    overflow: auto;
    padding: 16px;
`;
